<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "dynamic"
}
</script>

<style scoped>

</style>